import { Route, Routes } from 'react-router-dom';
import { Keyed } from '../../shared/components/Common';
import PackageSearch from './PackageSearch';
import PackageList from './PackageList';
import PackageDetails from './PackageDetails';
import PackageReview from './PackageReview';
import PackageConfirmation from './PackageConfirmation';
import PackageBookings from './PackageBookings';
import PackageBookingDetails from './PackageBookingDetails';

// Mounted at /packages/*
export default function PackageRoutes() {
  return (
    <Routes>
      <Route index element={<PackageSearch />} />
      <Route path="results" element={<Keyed page={PackageList} />} />
      <Route path="review" element={<PackageReview />} />
      <Route path="confirmation/:bookingId" element={<PackageConfirmation />} />
      <Route path="bookings" element={<PackageBookings />} />
      <Route path="bookings/:bookingId" element={<PackageBookingDetails />} />
      <Route path=":packageId" element={<PackageDetails />} />
    </Routes>
  );
}
